module.exports = __webpack_public_path__ + "img/2025-labor-day.a02dcdfb.jpg";